import React from 'react';
import ActionsPhotoNormalMedium from '@strava/icons/ActionsPhotoNormalMedium';
import Colors from '@strava/ui/colors';
import styles from './AddMediaThumbnail.scss';

function AddMediaThumbnail() {
  return (
    <div className={styles.container}>
      <div className={styles.maxWidth}>
        <div className={styles.center}>
          <ActionsPhotoNormalMedium fill={Colors.N40_STEEL} />
        </div>
      </div>
    </div>
  );
}

AddMediaThumbnail.propTypes = {};

export default AddMediaThumbnail;
